<app-title-bar [title]='"Selección"' [icon]="'assets/img/SVG/selectIcon.svg'"></app-title-bar>
<div id="divSelect" class="select">
  <div id="selection" class="selection">
    <form [formGroup]="selectForm">
      <mat-form-field appearance="fill">
        <mat-label>Seleccionar</mat-label>
        <mat-select placeholder="Seleccionar" formControlName="selectionForm" appearance="fill"
          (selectionChange)="startSelect()">
          <mat-select-trigger>
            Realiza la selección
          </mat-select-trigger>
          <mat-option value="point">
            <mat-icon svgIcon="point"></mat-icon>Seleccionar por punto
          </mat-option>
          <mat-option value="rectangle">
            <mat-icon svgIcon="rectangle"></mat-icon>Seleccionar por rectángulo
          </mat-option>
          <mat-option value="polygon">
            <mat-icon svgIcon="polygon"></mat-icon>Seleccionar por polígono
          </mat-option>
          <mat-option value="circle">
            <mat-icon svgIcon="circle"></mat-icon>Seleccionar por círculo
          </mat-option>
          <mat-option value="polyline">
            <mat-icon svgIcon="polyline"></mat-icon>Seleccionar por línea
          </mat-option>
        </mat-select>
      </mat-form-field>
    </form>
    <button mat-raised-button class="buttonAction" type="submit" (click)="clearResults()">Limpiar</button>
  </div>
</div>
<div id="results" class="listResults" *ngIf="resultSelect.length>0">
  <div id="results" class="results">
    <div class=" titleResult">Resultados</div>
  </div>
  <mat-accordion>
    <mat-expansion-panel *ngFor="let group of resultSelect" [disabled]="clickButton" (click)="clickButton=false">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-checkbox color="primary" [checked]="group.check" (click)="$event.stopPropagation(); changeCheck(group)"></mat-checkbox>
          &nbsp;{{group.features[0].layer.title}}
        </mat-panel-title>
        <mat-panel-description>
          {{group.features.length}}
        </mat-panel-description>
        <button mat-icon-button (click)="clickButton=true" [matMenuTriggerFor]="menuGroup">
          <mat-icon>more_horiz</mat-icon>
        </button>
        <mat-menu #menuGroup="matMenu">
          <button mat-menu-item (click)="mapService.getViewMap().goTo(group.features)">
            <mat-icon>zoom_in</mat-icon>
            <span>Acercar</span>
          </button>
          <button mat-menu-item (click)="removeGroup(group)">
            <mat-icon>remove</mat-icon>
            <span>Limpiar Selección</span>
          </button>
        </mat-menu>
      </mat-expansion-panel-header>
      <mat-list #results>
        <mat-list-item *ngFor="let result of group.features" class="itemResult">
          {{result.layer.title}}.{{result.uid}}
          <button mat-icon-button [matMenuTriggerFor]="menuItem">
            <mat-icon>more_horiz</mat-icon>
          </button>
          <mat-menu #menuItem="matMenu">
            <button mat-menu-item (click)="viewAttributesFeature(result)">
              <mat-icon>table_rows</mat-icon>
              <span>Ver Atributos</span>
            </button>
            <button mat-menu-item (click)="mapService.getViewMap().goTo(result)">
              <mat-icon>zoom_in</mat-icon>
              <span>Acercar</span>
            </button>
            <button mat-menu-item (click)="removeFeature(result, group)">
              <mat-icon>remove</mat-icon>
              <span>Limpiar Selección</span>
            </button>
          </mat-menu>
        </mat-list-item>
      </mat-list>
    </mat-expansion-panel>
  </mat-accordion>
  <div class="contenedor" *ngIf="download">
    <button mat-icon-button aria-label="Download selected element" matTooltip="Descargar"  (click)="downloadGeoJSON()" title="Descargar">
      <mat-icon class="custom-icon">download</mat-icon>
    </button>
  </div>
